import script from "./termsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./termsAndConditions.vue?vue&type=script&setup=true&lang=ts"

import "./termsAndConditions.vue?vue&type=style&index=0&id=4221a206&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4221a206"]])

export default __exports__